import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-4 border-b-2 border-gray-200" }
const _hoisted_2 = { class: "flex items-center mb-4" }
const _hoisted_3 = { class: "font-semibold text-black-700 text-nowrap" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "hidden" }, null, -1)

import { set } from '@vueuse/core';
import { ref, watch, PropType } from 'vue';
import { ChevronRight } from 'lucide-vue-next';
import { CustomerSession } from '@/http/customerSession';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerFieldSection',
  props: /*#__PURE__*/_mergeModels({
    title: String,
    hasToShowOnStart: {
        default: true,
        required: false
    },
    actionWhenShow: {
        required: false,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        default: () => { },
        type: Function
    }
}, {
    "modelValue": {
    required: false,
    type: Object as PropType<CustomerSession | undefined>,
},
    "modelModifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels(['circle-plus-action'], ["update:modelValue"]),
  setup(__props) {

const props = __props;
const show = ref<boolean>(props.hasToShowOnStart);
const customerSession = _useModel(__props, "modelValue");

watch(customerSession, (newSession, old) => {
    if (newSession?.id !== old?.id) set(show, props.hasToShowOnStart);
});



watch(show, async (newValue) => {
    if (newValue === true) {
        await props.actionWhenShow();
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(ChevronRight), {
        onClick: _cache[0] || (_cache[0] = () => show.value = !show.value),
        class: _normalizeClass({ 'rotate-90': show.value })
      }, null, 8, ["class"]),
      _createElementVNode("h2", _hoisted_3, _toDisplayString(__props.title), 1)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass({
            hidden: !show.value
        })
    }, [
      _renderSlot(_ctx.$slots, "default"),
      _renderSlot(_ctx.$slots, "circle-plus-reaction", {}, () => [
        _hoisted_4
      ])
    ], 2)
  ]))
}
}

})